 
import http from "@/http/service"
 
export default function DeletarServico(idServico=0){

    return http.delete(`/admin/servicos/${idServico}`)

}